module.exports = __webpack_public_path__ + "img/model2.d026e26a.png";